export const buildNumber = '20260827.2';
export const version = 'main';
export const latestCommit = '1764fce826d9bf995bd80b39d51fb76b22de7576';
